import StateControllerBase from "@/store/stateControllerBase";
import { setLoadingState } from "@/store/setLoadingState";

import PlatformController from "@/api/platformController";
const platformController = new PlatformController();

class Actions extends StateControllerBase {
  setDataLoading({ commit }, dataLoading) {
    commit("setDataLoading", dataLoading);
  }
  @setLoadingState
  async getPlatforms(_context, params) {
    return await platformController.getPlatforms(params);
  }
  @setLoadingState
  async getPlatformById(_context, id) {
    return await platformController.getPlatformById(id);
  }
  @setLoadingState
  async createPlatform(_context, params) {
    return await platformController.createPlatform(params);
  }
  @setLoadingState
  async editPlatform(_context, params) {
    return await platformController.editPlatform(params);
  }
  @setLoadingState
  async deletePlatform(_context, id) {
    return await platformController.deletePlatform(id);
  }

  async freezePlatform(_context, id) {
    return await platformController.freezePlatform(id);
  }

  async verifyPlatform(_context, id) {
    return await platformController.verifyPlatform(id);
  }

  async getPlatformKey(_context, id) {
    return await platformController.getPlatformKey(id);
  }

  async getPlatformDocs(_context) {
    return await platformController.getPlatformDocs();
  }
}
export default (new Actions).asPlainObject();